import { ListItem } from '@material-ui/core';
import { ComponentProps } from 'react';

export const defaultListItemStyles = 'w-auto h-7 px-2 mx-2 my-1 rounded-[5px]';

type DynamicListItemProps = { button: boolean; htmlId: string } & Omit<
  ComponentProps<typeof ListItem>,
  'button'
>;

export const DynamicListItem = ({
  button,
  children,
  disabled,
  htmlId,
  classes,
  className,
  ...props
}: DynamicListItemProps) => {
  const sharedProps: Pick<
    DynamicListItemProps,
    'disabled' | 'id' | 'data-testid' | 'classes' | 'className'
  > = {
    disabled,
    id: htmlId,
    'data-testid': htmlId,
    classes,
    className,
  };

  if (button) {
    return (
      <ListItem button={true} {...sharedProps} {...props}>
        {children}
      </ListItem>
    );
  } else {
    return (
      <ListItem<'li'> button={false} component="li" {...sharedProps}>
        {children}
      </ListItem>
    );
  }
};
